export default __webpack_public_path__ + "static/media/Bootstrap_-_adamr.space___Codecademy.6176c11c.pdf";